<template>
  <div>
    <div class="row mb-4">
      <div class="col-md-2">
        <label>Select custom range</label>
        <flat-pickr
            v-model="selectedDates"
            class="form-control"
            :config="{ mode: 'range' }"
            name="date"
            :style="{ backgroundColor: '#FFF' }"
            @on-change="handleDateChanged"
          ></flat-pickr>
      </div>
    </div>

    <!-- First Row: SMS and Broadcast SMS -->
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mt-0 mb-0 header-title">Number of SMS</h5>
            <div class="text-muted mt-1">Last 30 days</div>
            <div v-if="reports && !loadingReport">
              <div class="mt-2"><strong>Estimated Cost: {{ (reports.sms_outgoing * 0.0047) | currencySimple }}</strong></div>
              <div class="mt-2"><strong>Outgoing: {{ reports.sms_outgoing }}</strong></div>
              <div class="mt-2"><strong>Incoming: {{ reports.sms_incoming }}</strong></div>
            </div>
            <div class="media">
              <div class="media-body">
                <p v-if="reports && !loadingReport" class="mt-2">
                  Number of Incoming SMS is <strong class="text-success"
                    >up {{ reports.sms_week }}%</strong
                  > over last week and <strong class="text-success"
                    >up {{ reports.sms_month }}%</strong
                  > over last month
                </p>
                <div v-else>
                  <b-spinner />
                </div>
              </div>
            </div>
            <apexcharts
              v-if="reports && !loadingReport"
              type="bar"
              height="296"
              :series="smsChart.series"
              :options="smsChart.chartOptions"
            ></apexcharts>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mt-0 mb-0 header-title">Number of Broadcast SMS</h5>
            <div class="text-muted mt-1">Last 30 days</div>
            <div v-if="reports && !loadingReport">
              <div class="mt-2"><strong>Total: {{ reports.broadcast_sms_sent }}</strong></div>
            </div>
            <div class="media">
              <div class="media-body">
                <p v-if="reports && !loadingReport" class="mt-2">
                  Number of Broadcast SMS is <strong class="text-success"
                    >up {{ reports.broadcast_sms_week }}%</strong
                  > over last week and <strong class="text-success"
                    >up {{ reports.broadcast_sms_month }}%</strong
                  > over last month
                </p>
                <div v-else>
                  <b-spinner />
                </div>
              </div>
            </div>
            <apexcharts
              v-if="reports && !loadingReport"
              type="bar"
              height="296"
              :series="broadcastSmsChart.series"
              :options="broadcastSmsChart.chartOptions"
            ></apexcharts>
          </div>
        </div>
      </div>
    </div>

    <!-- Second Row: Emails and Voice Calls -->
    <div class="row mt-4">
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mt-0 mb-0 header-title">Number of Emails</h5>
            <div class="text-muted mt-1">Last 30 days</div>
            <div v-if="reports && !loadingReport">
              <div class="mt-2"><strong>Total: {{ reports.broadcast_emails_sent }}</strong></div>
            </div>
            <div class="media">
              <div class="media-body">
                <p v-if="reports && !loadingReport" class="mt-2">
                  Number of Broadcast Emails is <strong class="text-success"
                    >up {{ reports.broadcast_email_week }}%</strong
                  > over last week and <strong class="text-success"
                    >up {{ reports.broadcast_email_month }}%</strong
                  > over last month
                </p>
                <div v-else>
                  <b-spinner />
                </div>
              </div>
            </div>
            <apexcharts
              v-if="reports && !loadingReport"
              type="bar"
              height="296"
              :series="emailChart.series"
              :options="emailChart.chartOptions"
            ></apexcharts>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mt-0 mb-0 header-title">Number of Voice Calls</h5>
            <div class="text-muted mt-1">Last 30 days</div>
            <div v-if="reports && !loadingReport">
              <div class="mt-2"><strong>Total: {{ reports.voice_incoming }}</strong></div>
            </div>
            <div class="media">
              <div class="media-body">
                <p v-if="reports && !loadingReport" class="mt-2">
                  Number of Voice Calls is <strong class="text-success"
                    >up {{ reports.voice_week }}%</strong
                  > over last week and <strong class="text-success"
                    >up {{ reports.voice_month }}%</strong
                  > over last month
                </p>
                <div v-else>
                  <b-spinner />
                </div>
              </div>
            </div>
            <apexcharts
              v-if="reports && !loadingReport"
              type="bar"
              height="296"
              :series="voiceChart.series"
              :options="voiceChart.chartOptions"
            ></apexcharts>
          </div>
        </div>
      </div>
    </div>

    <!-- Revenue Reports Row -->
    <div class="row mt-4">
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mt-0 mb-0 header-title">Total Revenue</h5>
            <div class="text-muted mt-1">Last 30 days</div>
            <div v-if="reports && !loadingReport">
              <div class="mt-2"><strong>Total: {{ reports.total_revenue_generated | currencySimple }}</strong></div>
              <div class="mt-2"><strong>Avg per day: {{ (reports.total_revenue_generated / 30.0) | currencySimple }}</strong></div>
            </div>
            <div class="media">
              <div class="media-body">
                <p v-if="reports && !loadingReport" class="mt-2">
                  Revenue tracking across all channels
                </p>
                <div v-else>
                  <b-spinner />
                </div>
              </div>
            </div>
            <apexcharts
              v-if="reports && !loadingReport"
              type="bar"
              height="296"
              :series="totalRevenueChart.series"
              :options="totalRevenueChart.chartOptions"
            ></apexcharts>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mt-0 mb-0 header-title">Redemption Revenue</h5>
            <div class="text-muted mt-1">Last 30 days</div>
            <div v-if="reports && !loadingReport">
              <div class="mt-2"><strong>Total: {{ reports.total_redemption_revenue | currencySimple }}</strong></div>
              <div class="mt-2"><strong>Avg per day: {{ (reports.total_redemption_revenue / 30.0) | currencySimple }}</strong></div>
            </div>
            <div class="media">
              <div class="media-body">
                <p v-if="reports && !loadingReport" class="mt-2">
                  Revenue from coupon and offer redemptions
                </p>
                <div v-else>
                  <b-spinner />
                </div>
              </div>
            </div>
            <apexcharts
              v-if="reports && !loadingReport"
              type="bar"
              height="296"
              :series="redemptionRevenueChart.series"
              :options="redemptionRevenueChart.chartOptions"
            ></apexcharts>
          </div>
        </div>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <h5 class="card-title mt-0 mb-0 header-title">Order Revenue</h5>
            <div class="text-muted mt-1">Last 30 days</div>
            <div v-if="reports && !loadingReport">
              <div class="mt-2"><strong>Total: {{ reports.total_order_revenue | currencySimple }}</strong></div>
              <div class="mt-2"><strong>Avg per day: {{ (reports.total_order_revenue / 30.0) | currencySimple }}</strong></div>
            </div>
            <div class="media">
              <div class="media-body">
                <p v-if="reports && !loadingReport" class="mt-2">
                  Revenue from direct orders and purchases
                </p>
                <div v-else>
                  <b-spinner />
                </div>
              </div>
            </div>
            <apexcharts
              v-if="reports && !loadingReport"
              type="bar"
              height="296"
              :series="orderRevenueChart.series"
              :options="orderRevenueChart.chartOptions"
            ></apexcharts>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment-timezone'
import { formatCurrency } from '@src/helper'

export default {
  components: {
    apexcharts: VueApexCharts,
  },

  data() {
    return {
      reports: null,
      smsChartData: [],
      smsChart: {
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            x: {
              show: true,
            },
            y: {
              formatter: (value) => Math.round(parseFloat(value)).toString(),
            },
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#43d39e', '#4284f4'],
          xaxis: {
            type: 'string',
            categories: [],
            tooltip: {
              enabled: false,
            },
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              formatter: (value) => Math.round(value).toString(),
            },
          },
        },
        series: [],
      },
      broadcastSmsChartData: [],
      broadcastSmsChart: {
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            x: {
              show: true,
            },
            y: {
              formatter: (value) => Math.round(parseFloat(value)).toString(),
            },
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#43d39e'],
          xaxis: {
            type: 'string',
            categories: [],
            tooltip: {
              enabled: false,
            },
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              formatter: (value) => Math.round(value).toString(),
            },
          },
        },
        series: [],
      },
      voiceChartData: [],
      voiceChart: {
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            x: {
              show: true,
            },
            y: {
              formatter: (value) => Math.round(parseFloat(value)).toString(),
            },
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#43d39e'],
          xaxis: {
            type: 'string',
            categories: [],
            tooltip: {
              enabled: false,
            },
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              formatter: (value) => Math.round(value).toString(),
            },
          },
        },
        series: [],
      },
      emailChartData: [],
      emailChart: {
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            x: {
              show: true,
            },
            y: {
              formatter: (value) => Math.round(parseFloat(value)).toString(),
            },
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#f1556c'],
          xaxis: {
            type: 'string',
            categories: [],
            tooltip: {
              enabled: false,
            },
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            labels: {
              formatter: (value) => Math.round(value).toString(),
            },
          },
        },
        series: [],
      },
      totalRevenueChart: {
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            x: {
              show: true,
            },
            y: {
              formatter: formatCurrency,
            },
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#f1556c'],
          xaxis: {
            type: 'string',
            categories: [],
            tooltip: {
              enabled: false,
            },
            axisBorder: {
              show: false,
            },
          },
        },
        series: [],
      },
      redemptionRevenueChart: {
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            x: {
              show: true,
            },
            y: {
              formatter: formatCurrency,
            },
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#43d39e'],
          xaxis: {
            type: 'string',
            categories: [],
            tooltip: {
              enabled: false,
            },
            axisBorder: {
              show: false,
            },
          },
        },
        series: [],
      },
      orderRevenueChart: {
        chartOptions: {
          chart: {
            toolbar: {
              show: false,
            },
          },
          tooltip: {
            theme: 'dark',
            shared: true,
            intersect: false,
            x: {
              show: true,
            },
            y: {
              formatter: formatCurrency,
            },
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          dataLabels: {
            enabled: false,
          },
          colors: ['#4284f4'],
          xaxis: {
            type: 'string',
            categories: [],
            tooltip: {
              enabled: false,
            },
            axisBorder: {
              show: false,
            },
          },
        },
        series: [],
      },
      selectedDates: [
        moment()
          .subtract(30, 'days')
          .format(),
        moment().format(),
      ],
    }
  },

  mounted() {
    this.getReport(this.selectedDates)
  },

  methods: {
    getReport(dateRange) {
      this.loadingReport = true
      this.reports = null

      this.$store
        .dispatch('report/adminDashboard', dateRange)
        .then((reports) => {
          this.reports = reports

          this.smsChart.chartOptions.xaxis.categories = reports.labels
          this.smsChart.series = reports.sms_series

          // Split broadcast_series into SMS and Email charts
          this.broadcastSmsChart.chartOptions.xaxis.categories = reports.labels
          const broadcastSmsSeries = reports.broadcast_series.find(series => series.name === 'Broadcast SMS')
          this.broadcastSmsChart.series = broadcastSmsSeries ? [broadcastSmsSeries] : []

          this.emailChart.chartOptions.xaxis.categories = reports.labels
          const emailSeries = reports.broadcast_series.find(series => series.name === 'Emails')
          this.emailChart.series = emailSeries ? [emailSeries] : []

          this.voiceChart.chartOptions.xaxis.categories = reports.labels
          this.voiceChart.series = reports.voice_series

          // Setup revenue charts
          if (reports.revenue_series) {
            this.totalRevenueChart.chartOptions.xaxis.categories = reports.labels
            this.redemptionRevenueChart.chartOptions.xaxis.categories = reports.labels
            this.orderRevenueChart.chartOptions.xaxis.categories = reports.labels

            // Find each revenue type from the series
            const totalRevenueSeries = reports.revenue_series.find(series => series.name === 'Total Revenue')
            const redemptionRevenueSeries = reports.revenue_series.find(series => series.name === 'Redemption Revenue')
            const orderRevenueSeries = reports.revenue_series.find(series => series.name === 'Order Revenue')

            this.totalRevenueChart.series = totalRevenueSeries ? [totalRevenueSeries] : []
            this.redemptionRevenueChart.series = redemptionRevenueSeries ? [redemptionRevenueSeries] : []
            this.orderRevenueChart.series = orderRevenueSeries ? [orderRevenueSeries] : []
          }

          this.loadingReport = false
        })
        .catch(() => {
          this.loadingReport = false
        })
    },

    selectRange(event) {
      switch (event.target.value) {
        case 'last 3 days':
          this.selectedDates = [
            moment().format(),
            moment()
              .subtract(3, 'days')
              .format(),
          ]
          break
        case 'last 7 days':
          this.selectedDates = [
            moment().format(),
            moment()
              .subtract(7, 'days')
              .format(),
          ]
          break
        case 'this week':
          this.selectedDates = [
            moment()
              .startOf('isoWeek')
              .format(),
            moment()
              .endOf('isoWeek')
              .format(),
          ]
          break
        case 'last week':
          this.selectedDates = [
            moment()
              .subtract(1, 'weeks')
              .startOf('isoWeek')
              .format(),
            moment()
              .subtract(1, 'weeks')
              .endOf('isoWeek')
              .format(),
          ]
          break
        case 'this month':
          this.selectedDates = [
            moment()
              .startOf('month')
              .format(),
            moment().format(),
          ]
          break
        case 'last month':
          this.selectedDates = [
            moment()
              .subtract(1, 'months')
              .startOf('month')
              .format(),
            moment()
              .subtract(1, 'months')
              .endOf('month')
              .format(),
          ]
          break
      }
    },

    handleDateChanged(selectedDates) {
      if (selectedDates.length === 2) {
        // Format dates: start at midnight, end at 23:59:59
        const startDate = moment(selectedDates[0]).startOf('day').format('YYYY-MM-DD HH:mm:ss')
        const endDate = moment(selectedDates[1]).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        this.getReport([startDate, endDate])
      }
    },
  },
}
</script>
